import Main from './main'

const Airport = {
}

Main.init()